module.exports = __webpack_public_path__ + "static/quarterly-23ff6d54e7643532beeed8781292ca7b.jpg";